<template>
  <h6>
    Зображені на цій сторінці птахи і тварини, тексти, відео, озвучення і сюжети
    використані лише як художній образ, умовне позначення з метою реклами
    відповідного палива. При цьому під «арктичним дизелем» та «Pulls Diesel
    Арктика» мається на увазі Pulls Дизельне паливо Арктика
    (Pulls-ДП-Арк-Євро5-В0), яке рекомендовано при температурі повітря від нижче
    ніж мінус 20°С до мінус 40°С. Фактична гранична температура фільтрованості
    дизельного палива, яке реалізується на конкретному АЗК «ОККО», вказана в
    паспорті якості цього нафтопродукту.
  </h6>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  @import '~styles/scss/media.scss';
  h6 {
    font: 400 12px/16px ProximaNova;
    text-align: justify;
    color: white;
    opacity: 0.8;
    position: absolute;
    bottom: -40px;
    margin: 0;
    @include respond-to(tabletRotate) {
      position: static;
      bottom: unset;
      margin-top: 10px;
      margin-bottom: -25px;
      font-size: 10px;
      line-height: 12px;
    }
    @media screen and (max-height: 930px) and (min-width: 1200px) and (max-width: 1920px) {
      width: 50%;
    }
    @media screen and (max-height: 930px) and (min-width: 1260px) and (max-width: 1920px) and (max-height: 52.5vw) {
      width: 50%;
    }
    @media screen and (min-height: 640px) and (max-height: 730px) and (min-width: 1260px) and (max-width: 1415px) and (max-height: 52.5vw) {
      font-size: 10px;
      line-height: 12px;
      margin-bottom: -5px;
    }
    z-index: 50;
  }
  @media screen and (max-height: 700px) and (min-width: 992px) and (max-width: 1150px){
    h6 {
      position: static;
    }
  }
  @media screen and (max-height: 710px) and (min-width: 1150px) {
    h6 {
      position: static;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LegalText.vue